'use client';
import React from 'react';
import styles from './mfrm-modal-header.module.scss';

export interface IMfrmModalHeader {
  toggleModal(): void;
  headerTitle?: string;
}

export const MfrmModalHeader: React.FC<IMfrmModalHeader> = ({
  headerTitle,
  toggleModal,
}) => {
  return (
    <header className={styles.wrapper}>
      <h4 id="modalHeaderTitle" tabIndex={0}>
        {headerTitle}
      </h4>
      <button onClick={toggleModal} aria-label="close button">
        <span className="icon-cross" />
      </button>
    </header>
  );
};
